import React from 'react';

import { useAssociatedServices } from 'src/services/associatedServices';
import { useCurrentIssue } from 'src/services/currentIssue';
import { useJiraContext } from 'src/services/jira';
import { useSession } from 'src/services/session';

import CenteredSpinner from 'src/views/components/CenteredSpinner';
import ErrorMessage from 'src/views/components/ErrorMessage';
import ModalContainer from 'src/views/components/ModalContainer';

import CreateIncidentForm from './components/CreateIncidentForm';

const FormLoader = () => {
  const associatedServices = useAssociatedServices();
  const jira = useJiraContext();
  const session = useSession();

  const [currentIssue, currentIssueLoading, currentIssueError] = useCurrentIssue();

  const error = jira.error || currentIssueError;
  if (error) return <ErrorMessage error={error}/>;

  const loading = jira.loading || associatedServices.loading || currentIssueLoading || session.loading;
  if (loading) return <CenteredSpinner size="large"/>;

  if (session.loggedIn || associatedServices.hasAtLeastOneService) {
    return (
      <CreateIncidentForm
        issue={currentIssue}
        jira={jira}
        session={session}
      />
    );
  }

  return <ErrorMessage error="Please Connect Jira Project to PagerDuty Service or Login with PagerDuty to Create incidents"/>;
};

const ModalCreateIncident = () => (
  <ModalContainer title={'Create PagerDuty Incident'}>
    <FormLoader/>
  </ModalContainer>
);

export default ModalCreateIncident;
